module.exports = __webpack_public_path__ + "img/home_carousel_image_4.ccec5fc7.png";